module.exports = __webpack_public_path__ + "static/img/jrba.10f2fde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jrba.jpg
// module id = SNaL
// module chunks = 0